import React from "react";

const ScoreGauge = ({ score = 0, label = "AI score" }) => {
  const clamped = Math.max(0, Math.min(100, score || 0));
  const angle = (clamped / 100) * 180; // 0-180 deg
  // semi-circle path
  const radius = 56;
  const cx = 70;
  const cy = 70;
  const start = polar(cx, cy, radius, 180);
  const end = polar(cx, cy, radius, 180 - angle);
  const largeArc = angle > 180 ? 1 : 0;

  let color = "hsl(var(--destructive))";
  if (clamped >= 70) color = "hsl(var(--success))";
  else if (clamped >= 40) color = "hsl(var(--warning))";

  return (
    <div className="flex flex-col items-center" data-testid="ai-score-gauge">
      <svg width="140" height="82" viewBox="0 0 140 82">
        {/* background arc */}
        <path
          d={describeArc(cx, cy, radius, 180, 0)}
          fill="none"
          stroke="hsl(var(--muted))"
          strokeWidth="10"
          strokeLinecap="round"
        />
        {/* foreground arc */}
        <path
          d={`M ${start.x} ${start.y} A ${radius} ${radius} 0 ${largeArc} 1 ${end.x} ${end.y}`}
          fill="none"
          stroke={color}
          strokeWidth="10"
          strokeLinecap="round"
        />
      </svg>
      <div className="-mt-3 text-3xl font-display font-semibold tabular" data-testid="ai-score-gauge-value">
        {clamped}
      </div>
      <div className="text-xs text-muted-foreground uppercase tracking-wide">{label}</div>
    </div>
  );
};

function polar(cx, cy, r, deg) {
  const rad = ((deg - 90) * Math.PI) / 180;
  return { x: cx + r * Math.cos(rad), y: cy + r * Math.sin(rad) };
}

function describeArc(cx, cy, r, startDeg, endDeg) {
  const start = polar(cx, cy, r, startDeg);
  const end = polar(cx, cy, r, endDeg);
  const largeArc = startDeg - endDeg > 180 ? 1 : 0;
  return `M ${start.x} ${start.y} A ${r} ${r} 0 ${largeArc} 1 ${end.x} ${end.y}`;
}

export default ScoreGauge;
